<template>
  <div>
    <div class="header">
      <img :src="icon1" alt="" />
      <span>基本信息</span>
    </div>

    <div class="panel">
      <div class="label">经办部门</div>
      <div class="value1">
        {{ contractData.operationDeptName }}
      </div>

      <div class="label">经办人</div>
      <div class="value2">
        {{ contractData.operatorName }}
      </div>

      <div class="label">关联投标及项目委托</div>
      <div class="value3">
        {{ contractData.bidApprovalPname }}
      </div>

      <div class="label">合同编号</div>
      <div class="value1">
        {{ contractData.code }}
      </div>
      <div class="label">合同金额(万元)</div>
      <div class="value2">
        <Money :money="contractData.contractAmount" />
      </div>
      <div class="label">合同名称</div>
      <div class="value3">
        {{ contractData.name }}
      </div>

      <div class="label">业主方</div>
      <div class="value3">
        {{ contractData.partyAname }}
        <span v-if="!contractData.partyACode" style="color:#f00">（尚未在集团CRM系统登记）</span>
      </div>

      <div class="label">关联合同</div>
      <div class="value3">
        {{
                contractData.relationContractName
                ? contractData.relationContractName
                : "--"
                }}
      </div>

      <div class="label">用章名称</div>
      <div class="value3 left">
        <span v-for="(item, index) in sealType" :key="item" class="left">
          <DataDictFinder dictType="sealType" :dictValue="item" />
          <span style="padding: 0 2px" v-if="index !== sealType.length - 1">
            /
          </span>
        </span>
      </div>

      <div class="label" v-if="contractData.bidApprovalPname === '无'">
        说明
      </div>
      <div class="value3" v-if="contractData.bidApprovalPname === '无'">
        {{ contractData.bidApprovalInstruction }}
      </div>

      <div class="label">考核年份</div>
      <div class="value1">
        <a-select
          v-if="isContractRegisterJiruiNode"
          :disabled="disabled"
          :value="assessmentYear"
          @change="handleAssessmentYearChange"
          style="width: 100%"
          placeholder="请选择考核年份"
        >
          <a-select-option
            v-for="item in assessmentYearList"
            :key="item.value"
            :value="item.value"
          >{{ item.name }}</a-select-option>
        </a-select>
        <template v-else>
          <DataDictFinder v-if="contractData.assessmentYear" dictType="pallocateCalcFormula" :dictValue="contractData.assessmentYear" />
          <span v-else>--</span>
        </template>
      </div>

      <div class="label">承接方式</div>
      <div class="value2">
        <a-select
          v-if="isContractRegisterJiruiNode"
          :disabled="disabled"
          :value="undertakingMode"
          @change="handleUndertakingModeChange"
          style="width: 100%"
          placeholder="请选择承接方式"
        >
          <a-select-option
            v-for="item in undertakingModeList"
            :key="item.value"
            :value="item.value"
          >{{ item.name }}</a-select-option>
        </a-select>
        <template v-else>
          <DataDictFinder v-if="contractData.undertakingMode" dictType="contract_undertaking_method" :dictValue="contractData.undertakingMode" />
          <span v-else>--</span>
        </template>
      </div>

      <div class="label">经营组</div>
      <div class="value3">
        {{ contractData.businessGroup || '--' }}
      </div>

      <div class="label" v-if="isContractRegisterJiruiNode">经营对接人</div>
      <div class="value3" v-if="isContractRegisterJiruiNode">
        <BusinessContactSelector
          :disabled="disabled"
          @change="handleBusinessContactUserChange"
          :value="{
            businessGroupId: businessGroupId,
            businessGroup: businessGroup,
            businessContactUserId: businessContactUserId,
            businessContactUserName: businessContactUserName
          }"
        />
        <div v-if="businessContactValidateStatus === 'error'" style="color: #f5222d; font-size: 12px; margin-top: 4px;">
          {{ businessContactHelp }}
        </div>
      </div>
    </div>

    <div class="header">
      <img :src="icon2" alt="" />
      <span>项目信息</span>
    </div>

    <div class="panel">
      <div class="label">责任部门</div>
      <div class="value1">
        {{ contractData.productionUnitName }}
      </div>

      <div class="label">项目负责人</div>
      <div class="value2">
        {{ contractData.chargerName }}
      </div>

      <div class="label">所属区域</div>
      <div class="value1">
        {{ contractData.areaName }}/{{ contractData.subAreaName }} /{{
                contractData.l3AreaName
                }}
      </div>

      <div class="label">是否集团项目</div>
      <div class="value2">
        <span v-if="contractData.isGroup === 1">是</span>
        <span v-if="contractData.isGroup === 0">否</span>
      </div>

      <div class="label">合同性质</div>
      <div class="value1">
        {{ renderProperty(contractData.property) }}
      </div>

      <div class="label">联合体单位</div>
      <div class="value2">
        {{ contractData.unionType ? contractData.unionType : "--" }}
      </div>

      <div class="label">项目地点</div>
      <div class="value1">
        {{ contractData.belongProvince }}
        <span v-if="contractData.belongCity">/</span>
        {{ contractData.belongCity }}
        <span v-if="contractData.district">/</span>
        {{ contractData.district }}
      </div>

      <div class="label">国外</div>
      <div class="value2">
        {{ contractData.isAbroad ? contractData.isAbroad : "--" }}
      </div>

      <div class="label">总投资(万元)</div>
      <div class="value3">
        <Money :money="contractData.investment" />
      </div>

      <div class="label">服务内容</div>
      <div class="value3 left">
        <span v-for="(item, index) in phase" :key="item" class="left">
          <DataDictFinder dictType="phase" :dictValue="item" />
          <span style="padding: 0 2px" v-if="index !== phase.length - 1">
            /
          </span>
        </span>
      </div>
    </div>

    <div class="header">
      <img :src="icon3" alt="" />
      <span>专业规模</span>
    </div>

    <div class="panel">
      <div class="label">工程概况</div>
      <div class="value3">
        {{ contractData.scale }}
      </div>
    </div>

    <Padding />

    <ScaleList :list="scaleList" />

    <div class="header">
      <img :src="icon4" alt="" />
      <span>合同收款项</span>
    </div>

    <div class="collection">
      <div class="item">
        <div class="label">收款进度编号</div>
        <div class="label">收款项名称</div>
        <div class="label">收款比例</div>
        <div class="label">收款金额(万元)</div>
      </div>

      <div class="item" v-for="(item, index) in collectionList" :key="index">
        <div>{{ item.code }}</div>
        <div>{{ item.name }}</div>
        <div class="">{{ item.ratio }}%</div>
        <div class="">
          <Money :money="item.planReceipt" />
        </div>
      </div>
    </div>

    <div class="header">
      <img :src="icon5" alt="" />
      <span>附件</span>
    </div>

    <FileList :list="fileList" />
  </div>
</template>

<script>
import ScaleList from "./scale-list";
import FileList from "./file-list";
import BusinessContactSelector from "@/components/business-contact-selector";
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    ScaleList,
    FileList,
    BusinessContactSelector,
  },

  data() {
    return {
      icon1: require("@/assets/contract-register/icon-info.png"),
      icon2: require("@/assets/contract-register/icon-project.png"),
      icon3: require("@/assets/contract-register/icon-scale.png"),
      icon4: require("@/assets/contract-register/icon-collection.png"),
      icon5: require("@/assets/contract-register/icon-file.png"),
      businessContactValidateStatus: '',
      businessContactHelp: '',
    };
  },
  computed: {
    ...mapState("approval", ["detail"]),
    ...mapGetters("approval", [
      "isContractRegisterJiruiNode",
      "assessmentYear",
      "undertakingMode",
      "businessGroupId",
      "businessGroup",
      "businessContactUserId",
      "businessContactUserName"
    ]),
    extra() {
      return this.detail.extra ? this.detail.extra : {};
    },
    contractData() {
      return this.extra.contractData ? this.extra.contractData : {};
    },
    sealType() {
      return typeof this.contractData.sealType === "string"
        ? this.contractData.sealType.split(",")
        : [];
    },
    phase() {
      return typeof this.contractData.phase === "string"
        ? this.contractData.phase.split(",")
        : [];
    },
    scaleList() {
      return Array.isArray(this.contractData.scaleList)
        ? this.contractData.scaleList
        : [];
    },
    collectionList() {
      return Array.isArray(this.contractData.receiptList)
        ? this.contractData.receiptList
        : [];
    },
    fileList() {
      return typeof this.contractData.attachments === "string"
        ? this.contractData.attachments.split(",").map((item) => {
            return {
              name: item,
            };
          })
        : [];
    },

    ...mapGetters("setting", ["findDataDict"]),

    contractCategoryList() {
      return this.findDataDict("contractCategory");
    },

    // 考核年份列表
    assessmentYearList() {
      return this.findDataDict("pallocateCalcFormula");
    },

    // 承接方式列表
    undertakingModeList() {
      return this.findDataDict("contract_undertaking_method");
    },

    // 是否禁用编辑
    disabled() {
      return this.detail.status !== "ASSIGNED" && this.detail.status !== "RESUBMITED";
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.validateBusinessContactUser();
    });
  },

  methods: {
    ...mapMutations("approval", [
      "setAssessmentYear",
      "setUndertakingMode",
      "setBusinessGroupId",
      "setBusinessGroup",
      "setBusinessContactUserId",
      "setBusinessContactUserName"
    ]),

    handleAssessmentYearChange(value) {
      this.setAssessmentYear(value);
    },

    handleUndertakingModeChange(value) {
      this.setUndertakingMode(value);
      // 切换承接方式时触发经营对接人验证
      this.$nextTick(() => {
        this.validateBusinessContactUser();
      });
    },

    // 验证经营对接人
    validateBusinessContactUser() {
      if (this.undertakingMode === 'contract_undertaking_method_increment') {
        if (!this.businessContactUserId) {
          this.businessContactValidateStatus = 'error';
          this.businessContactHelp = '承接方式为增量时，经营对接人必填！';
          return false;
        }
      }
      this.businessContactValidateStatus = '';
      this.businessContactHelp = '';
      return true;
    },

    // 处理经营对接人选择
    handleBusinessContactUserChange(data) {
      if (data.businessContactUserId) {
        this.setBusinessContactUserId(data.businessContactUserId);
        this.setBusinessContactUserName(data.businessContactUserName);
        this.setBusinessGroupId(data.businessGroupId);
        this.setBusinessGroup(data.businessGroup);
        this.businessContactValidateStatus = '';
        this.businessContactHelp = '';
      } else {
        this.setBusinessContactUserId(null);
        this.setBusinessContactUserName(null);
        this.setBusinessGroupId(null);
        this.setBusinessGroup(null);
        this.$nextTick(() => {
          this.validateBusinessContactUser();
        });
      }
    },

    renderProperty(value) {
      let name = "";
      for (let i = 0; i < this.contractCategoryList.length; i++) {
        const item = this.contractCategoryList[i];
        if (Array.isArray(item.children)) {
          const obj = item.children.find((element) => element.value === value);
          if (obj) {
            name = obj.name;
            break;
          }
        }
      }
      return name;
    },
  },
};
</script>


<style lang="less" scoped>
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  &>div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    font-weight: bold;
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 12px;
  color: #1890ff;
  font-weight: bold;
  font-size: 14px;

  img {
    width: 14px;
    margin-right: 4px;
  }
}

.collection {
  border-top: 1px solid #e8e8e8;

  .item {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr 2fr;

    &>div {
      padding: 8px;
      border-bottom: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
    }

    &>div:first-child {
      border-left: 1px solid #e8e8e8;
    }

    .label {
      font-weight: bold;
      background-color: #fafafa;
    }
  }
}
</style>

